import React, { FC } from "react";
import Input from "./input";
import TextareaAutosize from "react-textarea-autosize";

interface TextAreaProps {
  label?: string;
  error?: string;
  onChange?: (e) => void;
  onBlur?: () => void;
  disabled?: boolean;
  placeholder?: string;
  value?: string;
  width?: number;
  minRows?: number;
  maxLength?: number;
}

const TextArea: FC<TextAreaProps> = ({
  label,
  error,
  onChange = (e) => {},
  onBlur = () => {},
  disabled = false,
  placeholder,
  value,
  width,
  minRows,
  maxLength,
}) => {
  let classes;

  if (error) {
    classes = "border-primary-red";
  } else {
    classes = "border-white border-opacity-64";
  }

  return (
    <div className="flex flex-col space-y-8">
      <Input label={label} error={error} width={width}>
        <TextareaAutosize
          className={`${classes} bg-transparent p-16 body2 rounded-sm border-2 placeholder-white placeholder-opacity-64 text-white focus:ring-none focus:border-current focus:outline-none w-full`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onBlur={onBlur}
          minRows={minRows}
          maxLength={maxLength}
        />
      </Input>
    </div>
  );
};

export default TextArea;
